import type { Environment } from "../types";

export const WALLET_API: Record<Environment, string> = {
  dev: "https://stg-wallet-server.crosstoken.io/api",
  stage: "https://stg-wallet-server.crosstoken.io/api",
  production: "https://wallet-server.crosstoken.io/api",
};

export const CHAIN_IDS: Record<
  Environment,
  { cross: number; bsc: number }
> = {
  dev: { cross: 612044, bsc: 97 },
  stage: { cross: 612044, bsc: 97 },
  production: { cross: 612055, bsc: 56 },
};

/**
 * Terms/Privacy 링크 폴백 URL. 호출부(dApp)가 `termsUrl` / `privacyUrl`을
 * 명시하지 않으면 dapp-ui가 이 CROSS 에코시스템 공통 문서로 내부 폴백해
 * 약관/정책 링크가 항상 노출되도록 한다. (WalletInfo / WalletConnectModal
 * 공통 단일 소스.)
 */
export const DEFAULT_TERMS_URL =
  "https://terms.onechain.nexus/docs/terms-july-23-2026";
export const DEFAULT_PRIVACY_URL =
  "https://terms.onechain.nexus/docs/pp-july-23-2026";

/**
 * Bridge 약관 동의 모달("Agree to Terms of Service")의 폴백 URL. 지갑 전체가
 * 아니라 ONEUSD 이용 약관에만 동의를 받는 화면이므로 CROSS 에코시스템 공통
 * 약관(`DEFAULT_TERMS_URL`)과 분리한다.
 */
export const DEFAULT_ONEUSD_TERMS_URL =
  "https://contents.crossdefi.io/Terms/terms/tos-26-07-09-oneusd.html";
